"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomState = void 0;
var RoomState;
(function (RoomState) {
    RoomState["New"] = "new";
    RoomState["WaitingPlayers"] = "waiting_players";
    RoomState["WaitingColorChoice"] = "waiting_color_choice";
    RoomState["Distribution"] = "distribution";
    RoomState["Playing"] = "playing";
    RoomState["Closing"] = "closing";
    RoomState["Ended"] = "ended";
})(RoomState || (exports.RoomState = RoomState = {}));
